import { topicWall } from "@/mocks/chigua";

export default function TopicWall() {
  return (
    <section id="topics" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600">
            <i className="ri-hashtag"></i> 标签聚合 · 话题墙
          </span>
          <h2 className="mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">把瓜按话题分好，点标签就能进区</h2>
          <p className="mt-2 text-sm text-foreground-600">综艺、剧集、实时热词……每个标签下都堆着一串更新。</p>
        </div>
        <a
          href="#collections"
          className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 whitespace-nowrap"
        >
          查看全部话题 <i className="ri-arrow-right-s-line"></i>
        </a>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2">
        {topicWall.map((group) => (
          <div
            key={group.group}
            className="rounded-lg bg-background-100 p-5 border border-background-200 transition-colors hover:border-accent-300"
          >
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-background-50">
                <i className={`${group.icon} text-lg`}></i>
              </span>
              <div>
                <h3 className="text-sm font-bold text-foreground-950">{group.group}</h3>
                <span className="text-[11px] text-foreground-500">话题 · 正在持续更新</span>
              </div>
            </div>
            <div className="mt-4 flex flex-wrap gap-2">
              {group.items.map((tag) => (
                <a
                  key={tag.label}
                  href="#latest"
                  className="group flex items-center gap-1.5 rounded-full bg-background-50 px-3 py-1.5 text-sm text-foreground-800 border border-background-200 transition-colors hover:bg-primary-500 hover:text-background-50 whitespace-nowrap"
                >
                  <i className="ri-hashtag text-xs text-primary-400 group-hover:text-background-50/80"></i>
                  {tag.label}
                  <span className="rounded-full bg-background-200 px-1.5 text-[10px] text-foreground-500 group-hover:bg-background-50/20 group-hover:text-background-50/80">
                    {tag.count}
                  </span>
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}